import React from 'react';
import { ImgLazyload } from '../index';
import Users from '../../../public/images/user-pic-grid.png';

export const SmallCard = ({
  type = 'default',
  highlight = '33k',
  highlightColor = 'white',
  description = 'Lorem ipsum Lorem ipsum Lorem ipsum',
  descriptionColor = '',
  background = '',
  bgColor = '',
  userGrid = false,
}) => (
  <div
    className={`smallcard-container ${bgColor ? `bg-${bgColor}` : ''}`}
    data-bg={background || ''}
    style={background ? { backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' } : {}}>
    <div className="d-flex">
      <h4 className={`text-${highlightColor} mb-0`}>{highlight}</h4>
      {userGrid && <ImgLazyload src={Users} alt="User's picture" className="mx-2" style={{ width: '69px', height: '20px', verticalAlign: 'top' }} />}
    </div>
    <div>
      <p className={`card-caption font-monsterArt ${descriptionColor ? `text-${descriptionColor}` : ''}`}>{description}</p>
    </div>
  </div>
);
 
export default SmallCard;
